import { claimsList } from './request';
export default {
  data() {
    return {
      data: [],
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        key: '1',
        align: 'center',
        scopedSlots: {
          customRender: 'index'
        },
        width: 80
      }, {
        slots: {
          title: '保单号'
        },
        dataIndex: 'policyNo',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '产品名称'
        },
        dataIndex: 'insuranceName',
        key: '6',
        align: 'center'
      }, {
        slots: {
          title: '保单归属'
        },
        dataIndex: 'customerName',
        key: '4',
        align: 'center'
      },
      // {title: '出单组织',  dataIndex: 'structureName', key: '3',align: 'center'},
      {
        slots: {
          title: '申请人'
        },
        dataIndex: 'userName',
        key: '7',
        align: 'center'
      }, {
        slots: {
          title: '申请时间'
        },
        dataIndex: 'createAt',
        key: '8',
        align: 'center',
        width: 180
      }, {
        slots: {
          title: '更新时间'
        },
        dataIndex: 'updateAt',
        key: '3',
        align: 'center',
        width: 180
      }, {
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        key: '9',
        align: 'center',
        width: 200
      }],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      }
    };
  },
  created() {
    this.getDataFun();
  },
  methods: {
    getDataFun() {
      claimsList({
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        status: 2
      }).then(res => {
        console.log(res);
        this.data = res.items;
        this.pagination.total = res.totalNum;
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    handleSee(val) {
      this.processShow = true;
      this.$nextTick(() => {
        this.$refs.processFrom.init(val);
      });
    }
  }
};